import { fetchCustomers } from "@/modules/customers/services/customers.services"
import { Customer } from "@/modules/customers/types"
import { StatusEnum } from "@/utils/constants"
import { useEffect, useState } from "react"

export const useCustomers = () => {
  const [customers, setCustomers] = useState<Customer[]>([])

  const getCustomers = async () => {
    const res = await fetchCustomers({ status: StatusEnum.ACTIVE, limit: 1000 })
    setCustomers(res.data.items)
  }

  useEffect(() => {
    getCustomers()
  }, [])

  return { customers }
}
